// extracted by mini-css-extract-plugin
export var container = "_qs-0";
export var dotAnimation = "_qs-2";
export var dotsLoading = "_qs-1";